// NewsletterInput.jsx
import React, { useState, useContext } from "react";
import Cookies from "js-cookie";
import ShopButton from "./ShopButton";
import addToKlaviyoNewsletter from "../functions/addToKlaviyoNewsletter";
import config from "../config";
import { ChevronRight } from "@mui/icons-material";
import { EnvContext } from "../context/EnvContext";
import { addDoc, collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const NewsletterInput = ({ onSignupComplete, buttonText = "Submit", type }) => {
  const environment = useContext(EnvContext);
  const [emailInput, setEmailInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission status
  const [successMessage, setSuccessMessage] = useState(""); // New state for success message

  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  const handleAcceptNewsletter = async () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
    if (!emailRegex.test(emailInput)) {
      setErrorMessage("Please enter a valid email address");
      setSuccessMessage(""); // Clear success message
      return;
    }
    setErrorMessage("");
    setSuccessMessage(""); // Clear success message

    setIsSubmitting(true); // Disable the button
    const firestore = db;
    try {
      // Check if the email already exists
      const existingEmailQuery = query(collection(firestore, `${collectionPath}Newsletter/Subscribers/DataBase`), where("email", "==", emailInput));
      const querySnapshot = await getDocs(existingEmailQuery);
      if (!querySnapshot.empty) {
        setErrorMessage("This email is already subscribed.");
        setSuccessMessage(""); // Clear success message
        return;
      }

      // Add the email to the newsletter collection
      await addDoc(collection(firestore, `${collectionPath}Newsletter/Subscribers/DataBase`), { email: emailInput, subscribedAt: new Date() });

      // Set the cookie so the modal does not show again
      Cookies.set("newsletterResponded", true, { expires: 1 });

      try {
        await addToKlaviyoNewsletter("Email", emailInput);
      } catch (error) {
        console.error(error);
      }

      // Notify parent that signup is complete
      if (onSignupComplete) {
        onSignupComplete();
      }

      setSuccessMessage("Successfully subscribed to the newsletter!"); // Set success message
    } catch (error) {
      console.error("Error signing up for newsletter:", error);
      setErrorMessage("Failed to sign up for the newsletter.");
      setSuccessMessage(""); // Clear success message
    } finally {
      setIsSubmitting(false); // Re-enable the button
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent form submission if inside a form
      handleAcceptNewsletter();
    }
  };

  if (type === "footer") {
    return (
      <div style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <style>
          {`input:-webkit-autofill {
  background-color: transparent !important;
  box-shadow: 0 0 0 100px transparent inset !important;
}
`}
        </style>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              position: "relative",
            }}
          >
            <input
              type="email"
              placeholder="Enter your email address"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              onKeyDown={handleKeyDown} // Add the keydown handler
              style={{
                border: errorMessage ? "1px solid red" : "1px solid #ccc",
                backgroundColor: "white",
                fontSize: ".9rem",
                color: "black",
                margin: "5px 0",
                borderRadius: "6px",
                width: "100%",
              }}
            />
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                borderRadius: "6px",
                padding: "0 10px",
                cursor: "pointer",
              }}
              onClick={handleAcceptNewsletter}
            >
              <ChevronRight style={{ color: "black" }} />
            </div>
          </div>
        </div>
        <div style={{ textAlign: "left", color: "white", fontSize: ".8rem", height: 15, marginTop: 20 }}>{errorMessage || successMessage}</div>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <input
        type="email"
        placeholder="Enter your email address"
        value={emailInput}
        onChange={(e) => setEmailInput(e.target.value)}
        onKeyDown={handleKeyDown} // Add the keydown handler
        style={{
          display: "flex",
          border: errorMessage ? "1px solid red" : "1px solid #ccc",
          borderRadius: "5px",
          background: "transparent",
          width: "100%",
          fontSize: ".9rem",
          color: "white",
        }}
      />

      <div style={{ textAlign: "left", color: "white", fontSize: ".8rem", height: 15 }}>
        {<span style={{ color: "red" }}>{errorMessage}</span> || successMessage}
      </div>
      <ShopButton
        text={isSubmitting ? "Submitting..." : buttonText} // Change the text
        theme="light"
        onClick={handleAcceptNewsletter}
        disabled={isSubmitting} // Disable the button
        style={{ backgroundColor: "#000", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", width: "100%" }}
      />
      <div style={{ fontSize: ".6rem", color: "white", textAlign: "justify", padding: "5px 0" }}>
        Join our newsletter for exclusive product recommendations and serious savings. Unsubscribe with the click of a button.
      </div>
    </div>
  );
};

export default NewsletterInput;
